import { logger } from "../../helper/logger";
import { PartialServiceCases, calcPartialServiceCase } from "./partialServiceConditions";
import { PartialServiceState, getPartialServiceState } from "./partialServiceUtils";
import { Models, SpeedtestState } from "@visonum/network-quality-sdk";

export interface UpdateAfterMeasurementIn {
    ispFootprint: string;
    partialService: Models.PartialServiceModel,
    speedtestState: SpeedtestState,
    currentDate: Date;
    lastModemResetDate: Date | null; // from local storage
    callbackCounter: number;
    currentDownloadSpeed: number;
    bookedDownloadSpeedMax: number | null;
}

export interface UpdateAfterMeasurementOut {
    partialServiceCase: PartialServiceCases; // store to local storage
    partialServiceState: PartialServiceState;
}

/* pure */
export const updateAfterMeasurementPure = (input: UpdateAfterMeasurementIn): UpdateAfterMeasurementOut => {
    const getPartialServiceCase = () => {
        if (input.ispFootprint !== "UM") {
            return PartialServiceCases.Default;
        }
        const modemResetDays = getDays(input.lastModemResetDate, input.currentDate);
        logger.info(`updateAfterMeasurementPure modemResetDays = ${modemResetDays}`);

        return calcPartialServiceCase(modemResetDays, input.speedtestState, input.partialService, input.callbackCounter, input.currentDownloadSpeed, input.bookedDownloadSpeedMax);
    }

    const partialServiceCase = getPartialServiceCase();
    const partialServiceState = getPartialServiceState(partialServiceCase, true);

    return {
        partialServiceCase,
        partialServiceState,
    }
}

/* pure */
export const getDays = (lastDate: Date | null, currentDate: Date): number | null =>
    lastDate === null ? null : (currentDate.getTime() - lastDate.getTime()) / (1000 * 3600 * 24);
